import { ReferenceExpression, SelectQueryBuilder, sql } from 'kysely';
import _ from 'lodash';
import { DatasetDatabase } from './datasetQueryBuilder';
import { DocumentContextQueryBuilderParams } from './datasetQueryBuilder.types';

export type ApplyShiftFilterParams<
  DB extends DatasetDatabase,
  TB extends keyof DB,
  O,
> = {
  qb: SelectQueryBuilder<DB, TB, O>;
  field: ReferenceExpression<DB, TB>;
  documentContext: DocumentContextQueryBuilderParams;
};

export function applyTimeFilter<
  DB extends DatasetDatabase,
  TB extends keyof DB,
  O,
>(params: ApplyShiftFilterParams<DB, TB, O>) {
  const from = params.documentContext?.from;
  const to = params.documentContext?.to;

  const builder = params.qb
    .$if(!_.isNil(from), db =>
      db.where(
        params.field,
        '>=',
        sql<Date>`${sql<Date>`cast( ${from} as timestamp)`}` as any,
      ),
    )

    .$if(!_.isNil(to), db =>
      db.where(
        params.field,
        '<=',
        sql<Date>`${sql<Date>`cast( ${to} as timestamp)`}` as any,
      ),
    );
  return builder;
}

export function applyShiftFilter<
  DB extends DatasetDatabase,
  TB extends keyof DB,
  O,
>(params: ApplyShiftFilterParams<DB, TB, O>) {
  const from = params.documentContext?.from;
  const to = params.documentContext?.to;
  const hoursBefore = -(params?.documentContext?.shiftDetectionOffset ?? 0);
  const hoursAfter = params?.documentContext?.shiftDetectionOffset ?? 0;

  const builder = params.qb
    .$if(!_.isNil(from), db =>
      db.where(
        params.field,
        '>=',
        sql<Date>`date_add('hour', ${hoursBefore}, ${sql<Date>`cast( ${from} as timestamp)`})` as any,
      ),
    )

    .$if(!_.isNil(to), db =>
      db.where(
        params.field,
        '<=',
        sql<Date>`date_add('hour', ${hoursAfter}, ${sql<Date>`cast( ${to} as timestamp)`})` as any,
      ),
    );
  return builder;
}

export function applyShiftPartitionFilter<
  DB extends DatasetDatabase,
  TB extends keyof DB,
  O,
>(params: ApplyShiftFilterParams<DB, TB, O>) {
  const from = params.documentContext?.from;
  const to = params.documentContext?.to;
  const hoursBefore = -(params?.documentContext?.shiftDetectionOffset ?? 0);
  const hoursAfter = (params?.documentContext?.shiftDetectionOffset ?? 0) + 24;
  const builder = params.qb
    .$if(!_.isNil(from), db =>
      db.where(
        params.field,
        '>=',
        sql<Date>`date_trunc('day', date_add('hour', ${hoursBefore}, ${sql<Date>`cast( ${from} as timestamp)`}))` as any,
      ),
    )

    .$if(!_.isNil(to), db =>
      db.where(
        params.field,
        '<',
        sql<Date>`date_trunc('day',date_add('hour', ${hoursAfter}, ${sql<Date>`cast( ${to} as timestamp)`}))` as any,
      ),
    );
  return builder;
}

// export function getReuseHashSources(): DatasetObjectQueryReuseHashSource{

// }
